import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import logoHostVSL from '@/assets/logo-hostvsl-white.png';

interface TemplateDarkMembersFooterProps {
  showTerms?: boolean;
  showPrivacy?: boolean;
  termsUrl?: string;
  privacyUrl?: string;
}

export function TemplateDarkMembersFooter({
  showTerms = true,
  showPrivacy = true,
  termsUrl = '#',
  privacyUrl = '#',
}: TemplateDarkMembersFooterProps) {
  useLanguage();
  const links = [
    { show: showTerms, label: translateInterfaceText("Termos de Uso"), url: termsUrl },
    { show: showPrivacy, label: translateInterfaceText("Privacidade"), url: privacyUrl },
  ].filter((link) => link.show);

  return (
    <footer 
      className="px-8 py-3"
      style={{ backgroundColor: '#0E0E0E' }}
    >
      <div className="max-w-[1400px] mx-auto px-4 lg:px-10 flex items-center justify-between">
        
        {/* Esquerda: Tecnologia de HostVSL */}
        <div className="flex items-center gap-1.5 text-[13px] text-white/80">
          <span>{translateInterfaceText("Tecnologia de")}</span>
          <a href="https://www.hostvsl.com.br" target="_blank" rel="noopener noreferrer">
            <img src={logoHostVSL} alt={translateInterfaceText("HostVSL")} className="h-4 w-auto" />
          </a>
        </div>

        {/* Direita: Links (ponta direita) */}
        {links.length > 0 && (
          <div className="flex items-center gap-3 text-[13px] text-white/80">
            {links.map((link, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span className="text-white/40">•</span>}
                <a href={link.url} className="hover:text-white transition-colors">
                  {link.label}
                </a>
              </React.Fragment>
            ))}
          </div>
        )}
        
      </div>
    </footer>
  );
}
